/* eslint react/no-array-index-key: 0 */
import React from 'react';
import PropTypes from 'prop-types';

import ShadedColorPaletteVertical from './ShadedColorPaletteVertical';
import PagedBrowser from '../../PagedBrowser';

import LayerLibraryLegend from '../../layerLibrary/legend/LayerLibraryLegend';
import OpportunityZonesLegend from '../layersLegend/OpportunityZonesLegend';
import SchoolRankLegend from '../layersLegend/SchoolRankLegend';
import BaseMap from '../../../enums/BaseMapTypes';

const CUSTOM_LIBRARY_LAYER_IDS = ['school_digger', 'opportunity_zones', BaseMap.STREET];

const MultiShadedAreaLegendDetailed = props => {
    const { mapInstance, renderer, libraryLegendInfo } = props;
    const { rules, nullDataRuleIndex, insufficientDataRuleIndex } = renderer;

    let activePageIndex = 0;
    const legendHighlighted = rules.some((variableRules, variableIndex) => {
        activePageIndex = variableIndex;
        return variableRules.some(rule => rule.highlighted);
    });

    const currentPageIndex = legendHighlighted ? activePageIndex : undefined;

    const pages = [];
    rules.forEach((rule, idx) => {
        const rulesArray = rules[idx];
        pages.push(
            <div key={idx} className="vertical-shaded-area-legend flex-it column">
                <ShadedColorPaletteVertical
                    mapInstanceId={mapInstance.id}
                    nullDataRuleIndex={nullDataRuleIndex[idx]}
                    insufficientDataRuleIndex={insufficientDataRuleIndex[idx]}
                    rules={rulesArray}
                    variableIdx={idx}
                    legendHighlighted={legendHighlighted}
                />
            </div>
        );
    });

    libraryLegendInfo.filter(lg => CUSTOM_LIBRARY_LAYER_IDS.indexOf(lg.id) !== -1)
        .forEach(layerGroup => {
            switch (layerGroup.id) {
            case 'school_digger':
                pages.push(<SchoolRankLegend key="school-rank-legend" mapInstance={mapInstance} />);
                break;
            case 'opportunity_zones':
                pages.push(<OpportunityZonesLegend key="opportunity-zones-legend" mapInstance={mapInstance} />);
                break;
            }
        });

    // list of library layers without the custom ones
    const filteredLibraryLayers = libraryLegendInfo && libraryLegendInfo.filter(lg => CUSTOM_LIBRARY_LAYER_IDS.indexOf(lg.id) === -1);

    if (filteredLibraryLayers && filteredLibraryLayers.length > 0) {
        pages.push(
            <LayerLibraryLegend
                key="layer-library-legend"
                className="layer-library-legend"
                libraryGroups={filteredLibraryLayers}
                mapInstanceId={mapInstance.id}
            />
        );
    }

    return (
        <PagedBrowser currentPage={currentPageIndex}>
            {pages}
        </PagedBrowser>
    );
};

MultiShadedAreaLegendDetailed.propTypes = {
    mapInstance: PropTypes.object.isRequired,
    renderer: PropTypes.object.isRequired,
    libraryLegendInfo: PropTypes.array,
};

MultiShadedAreaLegendDetailed.defaultProps = {
    libraryLegendInfo: undefined,
};

export default MultiShadedAreaLegendDetailed;
